module.exports = __webpack_public_path__ + "img/Entertainment_2208x1242_4.0630ebbe.png";